export const dosage = {
  takeWith: "Take with",
  takeWithInstruction: "Take with {{ takeWith }}",
  notSelected: "Not selected",
  food: "Food",
  water: "Water",
  emptyStomach: "Empty stomach",
  dosageNonNumeric: "Dosage must be numeric",
  serving: " serving",
  serving_plural: " servings",
  additionalNotes: "Additional notes",
} as const;
